import { render, staticRenderFns } from "./ShowLicencia.vue?vue&type=template&id=0ab1325a&"
import script from "./ShowLicencia.vue?vue&type=script&lang=js&"
export * from "./ShowLicencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports